import PropTypes from 'prop-types';
import React, { Component } from 'react';
import IsolatedConcept from './IsolatedConcept';
import ActionText from '../../core/ActionText';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../../core/style/gstheme';

class ConceptStructure extends Component {

  render() {

    const { onSelect, concepts, noneFound, schemeIRI, graph, activeConcept, iriOptions, useWorkflow,
      defaultLang, viewLang, isReadOnly, hideInScheme, showInScheme, addToScheme, flat } = this.props;

    return (
      <div data-test="concept-list">
        {noneFound || !concepts ?
          <ActionText offset="100px" format="result">No results.</ActionText>
          :
          concepts.map(concept => <IsolatedConcept
            key={concept}
            id={concept}
            flat={flat}
            useWorkflow={useWorkflow}
            schemeIRI={schemeIRI}
            iriOptions={iriOptions}
            hideInScheme={hideInScheme}
            showInScheme={showInScheme}
            addToScheme={addToScheme}
            lang={defaultLang}
            viewLang={viewLang}
            activeConcept={activeConcept}
            graph={graph}
            isReadOnly={isReadOnly}
            onSelect={onSelect} />)
        }
      </div>
    );
  }

}

ConceptStructure.propTypes = {
  schemeIRI: PropTypes.string,
  concepts: PropTypes.array,
  hideInScheme: PropTypes.bool,
  showInScheme: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  flat: PropTypes.bool,
  useWorkflow: PropTypes.bool,
  activeConcept: PropTypes.string,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
  graph: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  nonFound: PropTypes.bool,
  classes: PropTypes.object,
  iriOptions: PropTypes.object
};

export default withStyles(styles)(ConceptStructure);